export default "__VITE_ASSET__CoVT_xwm__"